import * as React from 'react';
import XSVG from './svg/XSVG';

export interface PopoverCloseProps {
	toggle: () => void;
	hideText?: boolean;
}

/**
 * Popover close component to close popovers.
 *
 * @class PopoverClose
 * @extends {React.Component<PopoverCloseProps>}
 */
class PopoverClose extends React.Component<PopoverCloseProps> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { toggle, hideText = false } = this.props;

		return (
			<div className="popover-close">
				<button className="popover-close__btn" onClick={toggle} data-testid="popover-close-btn">
					<span
						className={hideText ? 'popover-close__text popover-close__text--hidden' : 'popover-close__text'}
					>
						close
					</span>
					<span className="popover-close__x">
						<XSVG class="popover-close__x-icon" />
					</span>
				</button>
			</div>
		);
	}
}

export default PopoverClose;
